export default __webpack_public_path__ + "static/media/digidrive_privacy.d40c304a.pdf";